import {z} from 'zod'
import {BackgroundImageSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/backgroundImage'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {PrimerCardsSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerCards'
import {PrimerComponentCtaBannerSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCtaBanner'
import {PrimerComponentFaqGroupSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentFaqGroup'
import {PrimerComponentProseSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentProse'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {GenericCallToActionSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/genericCallToAction'

export const TemplateArticleSchema = buildEntrySchemaFor('templateResourcesArticle', {
  fields: z.object({
    title: z.string(),
    heroBackgroundImage: BackgroundImageSchema.optional(),
    lede: RichTextSchema,
    content: PrimerComponentProseSchema,
    featuredCallToAction: GenericCallToActionSchema.optional(),
    ctaBanner: PrimerComponentCtaBannerSchema.optional(),
    cards: PrimerCardsSchema.optional(),
    faq: PrimerComponentFaqGroupSchema.optional(),
    excerpt: RichTextSchema,
  }),
})

export type ArticlePage = z.infer<typeof TemplateArticleSchema>
